module.exports = __webpack_public_path__ + "img/gift-box.36734fac.svg";